(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerRaceResumeController', RunnerRaceResumeController);

    RunnerRaceResumeController.$inject = ['RunnerRaceResume'];

    function RunnerRaceResumeController(RunnerRaceResume) {

        var vm = this;

        vm.runnerRaceResumes = [];

        loadAll();

        function loadAll() {
            RunnerRaceResume.query(function(result) {
                vm.runnerRaceResumes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
